<div class="dialog__container">
  <div class="dialog__container-header">
    <div class="dialog__container-header-title">
      <div class="dialog__container-heading">Promote Contact to HDMA</div>
      <span class="dialog__container-sub-heading">
        {{ contactName }}
      </span>
    </div>
    <button mat-icon-button type="button" aria-label="Close" (click)="handleCancel()" data-pw="close-promote-dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content class="dialog__container-content">
  <div class="warning-section">
    <mat-icon class="warning-icon">warning</mat-icon>
    <div class="warning-text">
      <p class="warning-title">Important: This action is immediate</p>
      <p class="warning-message">
        You are about to promote <strong>{{ contactName }}</strong> to the HDMA (Highest Decision Making Authority)
        role.
      </p>
    </div>
  </div>

  <div class="info-section">
    <h3>What will happen:</h3>
    <ul>
      @if (isAdminView) {
        <li>
          {{ contactName }} will immediately become the HDMA for this {{ isInstitutionView ? 'institution' : 'school' }}
        </li>
        <li>The current HDMA ({{ currentHDMAName }}) will lose HDMA privileges</li>
        <li>All HDMA references will be updated to the new HDMA</li>
      } @else {
        <li>{{ contactName }} will immediately become the HDMA for this school</li>
        <li>You will lose HDMA privileges</li>
        <li>You will be logged out and need to log back in</li>
        <li>All HDMA references will be updated to the new HDMA</li>
      }
    </ul>
  </div>

  <form [formGroup]="form">
    <div class="confirmation-section">
      <p class="confirmation-label">
        To confirm this action, please type <strong>{{ confirmationWord }}</strong> below:
      </p>
      <mat-form-field appearance="outline" class="confirmation-input">
        <mat-label>Type "{{ confirmationWord }}" to confirm</mat-label>
        <input matInput formControlName="confirmationText" autocomplete="off" placeholder="{{ confirmationWord }}" />
        @if (form.get('confirmationText')?.hasError('invalidConfirmation') && form.get('confirmationText')?.touched) {
          <mat-error> Please type "{{ confirmationWord }}" exactly as shown </mat-error>
        }
      </mat-form-field>
    </div>
  </form>

  <mat-dialog-actions class="dialog__container-actions">
    <button mat-stroked-button type="button" (click)="handleCancel()" class="secondary-button">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="!isConfirmationValid"
      (click)="handleConfirm()"
      class="dialog-save-button"
      data-pw="confirm-promote">
      Promote to HDMA
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
